module.exports = __webpack_public_path__ + "img/should_exclude.89e97121.svg";